// src/services/api/procurement/debitNote.js
// Endpoints per rettzy-backend/src/modules/procurement/routes/debitNote.routes.js
import { apiClient } from '../base';

export const getDebitNotes = async (params = {}) => {
  const response = await apiClient.get('/procurement/debit-notes', { params });
  return response.data;
};

export const getDebitNote = async (debitNoteId) => {
  const response = await apiClient.get(`/procurement/debit-notes/${debitNoteId}`);
  return response.data;
};

export const issueDebitNote = async (data) => {
  const response = await apiClient.post('/procurement/debit-notes', data);
  return response.data;
};

export const applyDebitNote = async (debitNoteId, data) => {
  const response = await apiClient.post(`/procurement/debit-notes/${debitNoteId}/apply`, data);
  return response.data;
};

export const cancelDebitNote = async (debitNoteId) => {
  const response = await apiClient.post(`/procurement/debit-notes/${debitNoteId}/cancel`);
  return response.data;
};
